import ReactGA from 'react-ga';


export default function saveGAEvent(data){
    if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development')
        return

    ReactGA.initialize('UA-158933671-1');
    ReactGA.event(data)
}